import { useCancellationAlertsStore } from '@/stores/cancellationAlertsStore';
import type { CreateCancellationAlertParams, GetCancellationAlertsFilters } from "@/services/data/cancellationAlerts";

export const createCancellationAlert = async (params: CreateCancellationAlertParams) => {
  const result = await useCancellationAlertsStore.getState().createAlert(params);
  if (result.success) {
    return { data: result.data, error: null };
  }
  return { data: null, error: result.error };
};

export const getCancellationAlerts = async (filters?: GetCancellationAlertsFilters) => {
  await useCancellationAlertsStore.getState().fetchAlerts(filters);
  const alerts = useCancellationAlertsStore.getState().alerts;
  return { data: alerts, error: null };
};

export const markAlertAsRead = async (alertId: string) => {
  const result = await useCancellationAlertsStore.getState().markAsRead(alertId);
  if (result.success) {
    return { data: result.data || null, error: null };
  }
  return { data: null, error: result.error };
};

export type { CreateCancellationAlertParams, GetCancellationAlertsFilters };